/** The label of an applied group the user does not see, e.g. one that was deleted or is in a link of another user */
export const UNKNOWN_GROUP_LABEL = "Unknown group";

/** The group a filter option matches the projects in */

/**
 * Returns the filter options for the groups among the IDs, which match the projects in them. The
 * names of the groups are not known from the IDs, so they are labeled as unknown.
 */
export function getGroupFilterOptions(filterIds) {
  return Object.fromEntries(filterIds.filter(filterId => filterId.trim() !== "").map(filterId => [filterId, getGroupFilterOption({
    id: filterId,
    name: UNKNOWN_GROUP_LABEL
  })]));
}

/** Returns the filter option for the group, which matches the projects in it */
export function getGroupFilterOption({
  id,
  name
}) {
  return {
    id,
    label: name,
    hasEntityPassedFilter: project => project.groupId === id
  };
}